import { DateTimePickerDE } from "../common/DateTimePickerDE";

export type StringFields<T> = {
  [K in keyof T]: T[K] extends Date | null ? K : never;
}[keyof T];

type ProcessDataDateTimeFieldDEProps<T> = {
  value: Date | null | undefined;
  field: StringFields<T>;
  disableOpenPicker?: boolean;
  label?: string;
  format?: string;
  disabled?: boolean;
  clearable?: boolean;
  onChange?: (date: Date | null) => void;
  onBlur?: (date: Date | null) => void;
  onFocus?: () => void;
  skipBlurOnClear?: boolean;
  readOnly?: boolean;
};
export const ProcessDataDateTimeFieldDE = <T,>({
  value,
  field,
  label,
  disableOpenPicker = true,
  format = "HH:mm",
  disabled = false,
  clearable = true,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  skipBlurOnClear = false,
  readOnly = false,
}: ProcessDataDateTimeFieldDEProps<T>) => {
  return (
    <DateTimePickerDE
      disabled={disabled}
      disableOpenPicker={disableOpenPicker}
      clearable={clearable}
      format={format}
      label={label || String(field)}
      value={value || null}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      skipBlurOnClear={skipBlurOnClear}
      readOnly={readOnly}
    />
  );
};
